import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id D0F312B5-8B3B-4E68-BF0B-691D4F129749
 * name chart-sankey
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-sankey.svg
 * tags
 * - Math 
 */
export const ChartSankeyIcon = createSvgIcon(<><path d="M22 5H4V2H2V22H22V20H4V9C8.09 9 10.13 11 12.29 13.21S17.09 18 22 18V16C17.91 16 15.87 14 13.71 11.79S8.91 7 4 7H22Z" /></>, 'ChartSankeyIcon');
export default ChartSankeyIcon